import BSONObjectID from 'bson-objectid'

export default function objectId(): string {
  // eslint-disable-next-line @typescript-eslint/no-base-to-string -- FIXME: Fix this ESLint violation!
  return new BSONObjectID().toString()
}
